/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_PasswordInputs */

const cs_documents_share_password = /** @type {(inputs: Documents_Share_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo (volitelné)`)
};

const en_documents_share_password = /** @type {(inputs: Documents_Share_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password (optional)`)
};

/**
* | output |
* | --- |
* | "Password (optional)" |
*
* @param {Documents_Share_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_password = /** @type {((inputs?: Documents_Share_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_password(inputs)
	return cs_documents_share_password(inputs)
});